/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BuildingUpdate { 
    Name?: string | null;
    Id: string;
    Latitude?: number | null;
    Longitude?: number | null;
}

